module.exports = __webpack_public_path__ + "img/virtual-meeting.043160ad.jpg";